// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EditEmployeeBonus__wrap--1Rj50","head":"EditEmployeeBonus__head--IVYxu"};